import React from 'react';

// Hooks

// Components
import WpProgressBar, { Size as ProgressBarSize } from 'Wpds/components/progress/WpProgressBar';

// Styles
import './GoalProgressWrapper.scss';

export type labelSize = 'sm' | 'md' | 'lg';

const DEFAULT_LABEL = { size: 'sm', visible: true };

export type labelType = {
  label: string | React.ReactNode;
  size?: labelSize;
  visible?: boolean;
};

type Props = {
  progressBarSize?: ProgressBarSize;
  percent: number;
  topLabel?: labelType;
  bottomLabel?: labelType;
  inlineStartLabel?: labelType;
  inlineEndLabel?: labelType;
};

const GoalProgressWrapper = ({
  topLabel,
  bottomLabel,
  inlineStartLabel,
  inlineEndLabel,
  percent,
  progressBarSize = 'sm',
}: Props) => {
  const normalizedTopLabel = topLabel ? { ...DEFAULT_LABEL, ...topLabel } : null;
  const normalizedBottomLabel = bottomLabel ? { ...DEFAULT_LABEL, ...bottomLabel } : null;
  const normalizedInlineStartLabel = inlineStartLabel ? { ...DEFAULT_LABEL, ...inlineStartLabel } : null;
  const normalizedInlineEndLabel = inlineEndLabel ? { ...DEFAULT_LABEL, ...inlineEndLabel } : null;

  const baseClassName = 'GoalProgressWrapper';

  const percentToRender = percent === 0 ? 2 : percent;

  return (
    <div className={baseClassName}>
      {normalizedTopLabel && normalizedTopLabel.visible && (
        <div
          className={`${baseClassName}__label ${baseClassName}__label--size-${normalizedTopLabel.size} ${baseClassName}__label--top`}
        >
          {normalizedTopLabel.label}
        </div>
      )}

      <div className={`${baseClassName}__bar-wrapper`}>
        {normalizedInlineStartLabel && normalizedInlineStartLabel.visible && (
          <span
            className={`${baseClassName}__label ${baseClassName}__label--size-${normalizedInlineStartLabel.size} ${baseClassName}__label--inline-start`}
          >
            {normalizedInlineStartLabel.label}
          </span>
        )}
        <div className={`${baseClassName}__bar-wrapper__bar`}>
          <WpProgressBar size={progressBarSize} percent={percentToRender} />
        </div>
        {normalizedInlineEndLabel && normalizedInlineEndLabel.visible && (
          <span
            className={`${baseClassName}__label ${baseClassName}__label--size-${normalizedInlineEndLabel.size} ${baseClassName}__label--inline-end`}
          >
            {normalizedInlineEndLabel.label}
          </span>
        )}
      </div>
      {normalizedBottomLabel && normalizedBottomLabel.visible && (
        <div
          className={`${baseClassName}__label ${baseClassName}__label--size-${normalizedBottomLabel.size} ${baseClassName}__label--bottom`}
        >
          {normalizedBottomLabel.label}
        </div>
      )}
    </div>
  );
};

export default GoalProgressWrapper;
